// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3lrKj","error":"Textarea_error__13YY2","readonly":"Textarea_readonly___wjM8","disabled":"Textarea_disabled__PQiwm"};